module.exports = __webpack_public_path__ + "static/Platinum_Realty_Orange-ca5cd3031f7e720294fe07f3de256e24.jpg";